import { render, staticRenderFns } from "./header-usepsc.vue?vue&type=template&id=435f2d4d&scoped=true&"
import script from "./header-usepsc.vue?vue&type=script&lang=js&"
export * from "./header-usepsc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435f2d4d",
  null
  
)

export default component.exports